<template>
  <div class="roles">
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("headings.roles") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="roles"
      hide-default-footer
      :mobile-breakpoint="zero"
      disable-pagination
    >
      <!-- slot="items" slot-scope="props" -->
      <template v-slot:item="props">
        <tr>
          <td class="td_name text-center" :title="props.item.display_name">
            {{ props.item.display_name }}
          </td>
          <td class="td_desc text-center" :title="props.item.description">
            {{ props.item.description }}
          </td>
          <td class="text-center">
            <v-icon
              @click="editPermissions(props.item.id)"
              class="mr-2 edit"
              title="Edit Permissions"
              small
              >mdi-pencil</v-icon
            >
            <v-icon
              @click="deleteRole(props.item.id, props.index)"
              class="delete"
              title="Delete Permissions"
              small
              >mdi-delete</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { indexRoles, deleteRole } from "@/api/roles.js";
import { myMixins } from "@/components/Mixins.js";

export default {
  components: {},
  mixins: [myMixins],
  data() {
    return {
      roles: [],
      headers: [
        {
          text: this.$t("table.name"),
          sortable: false,
          value: "name",
          align: "center"
        },
        {
          text: this.$t("table.description"),
          value: "Description",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("table.showEditDelete"),
          value: "Description",
          sortable: false,
          align: "center"
        }
      ],
      zero: 0
    };
  },
  created() {
    indexRoles()
      .then(res => {
        this.roles = res.data.data;
      })
      .catch(err => console.log(err));
  },
  methods: {
    deleteRole(id, index) {
      this.popUp(this.$t("messages.warning"), "warning").then(value => {
        if (!value.dismiss) {
          deleteRole(id)
            .then(res => {
              console.log(res);
              this.roles.splice(index, 1);
              this.roles = [...this.roles];
            })
            .catch(err => console.log(err));
        }
      });
    },
    editPermissions(id) {
      this.$router.push({ path: "/roles/new", query: { id } });
    }
  }
};
</script>
